import _classCallCheck from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * @internal
 */
var InMemoryStorage = /*#__PURE__*/function () {
  function InMemoryStorage() {
    _classCallCheck(this, InMemoryStorage);

    this.storage = new Map();
  }

  _createClass(InMemoryStorage, [{
    key: "length",
    get: function get() {
      return this.storage.size;
    }
  }, {
    key: "key",
    value: function key(index) {
      if (index > this.length - 1) {
        return null;
      }

      return Array.from(this.storage.keys())[index];
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this.storage.set(key, value);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var _this$storage$get;

      return (_this$storage$get = this.storage.get(key)) !== null && _this$storage$get !== void 0 ? _this$storage$get : null;
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      this.storage.delete(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.storage.clear();
    }
  }]);

  return InMemoryStorage;
}();

export { InMemoryStorage };